export interface IDateRangeFilter {
  from?: Date | string;
  to?: Date | string;
  id: CustomDateRangeFilterId;
}

export interface IDateRangeWithCompareFilter extends IDateRangeFilter {
  compare?: IDateRangeFilter;
}

export enum CustomDateRangeFilterId {
  Today = "today",
  Yesterday = "yesterday",
  Last7Days = "last_7_days",
  LastMonth = "last_month",
  SamePeriod = "same_period",
  SamePeriodInLastYear = "same_period_in_last_year",
  CustomPeriod = "custom_period",
  CustomTime = "custom_time",
}

export const DateRangeFilterFormattedValues = {
  [CustomDateRangeFilterId.Today]: "Today",
  [CustomDateRangeFilterId.Yesterday]: "Yesterday",
  [CustomDateRangeFilterId.Last7Days]: "Last 7 days",
  [CustomDateRangeFilterId.LastMonth]: "Last month",
  [CustomDateRangeFilterId.CustomPeriod]: "Custom date range",
  [CustomDateRangeFilterId.CustomTime]: "Custom time span",
};
